import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { AdpClient } from './api/client';
import { awsNativeOrderRef, databricksOrderRef, rootRouteRef } from './routes';
import { adpApiRef } from './api/api';

export const adpPlugin = createPlugin({
  id: 'adp',
  apis: [
    createApiFactory({
      api: adpApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory({ discoveryApi, fetchApi }) {
        return new AdpClient({
          discoveryApi,
          fetchApi,
        });
      },
    }),
  ],
  routes: {
    root: rootRouteRef,
    tenantOrder: awsNativeOrderRef,
    databricksOrder: databricksOrderRef,
  },
});

export const AdpPage = adpPlugin.provide(
  createRoutableExtension({
    name: 'AdpPage',
    component: () => import('./App').then(m => m.App),
    mountPoint: rootRouteRef,
  }),
);
